import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Breadcrumb from '../Component/Breadcrumb'
const SchoolStaff = () => {
    return (
        <>
            <Header />
            <Breadcrumb title="School Staff" midBreadcrumb="Office Bearers" mainBreadcrumb="School Staff" ></Breadcrumb>
            <div className='inner-page'>
                <div className='container'>
                    <div className="col-12">
                        <h2 className="mainhead mainhead-center" >STAFF DETAILS
                        </h2>
                        {/* <div className="tablescroll table-responsive">
                            <table className="table table-bordered text-center">
                                <thead className="aos-init aos-animate">
                                    <tr>
                                        <td>S.No.</td>
                                        <td>Name</td>
                                        <td>Designation</td>
                                        <td>Categories</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>FR. EULALIO JULIO FERNANDES</td>
                                        <td>PRINCIPAL</td>
                                        <td>PRINCIPAL</td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>SR. JUBY JOSEPH</td>
                                        <td>HEAD MISTRESS</td>
                                        <td>HM</td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td>MR. VALAMBURI AYYAPPAN</td>
                                        <td>PGT</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>4</td>
                                        <td>MR. REGIN BABU</td>
                                        <td>PGT</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>5</td>
                                        <td>MRS. ANSHU SAINI</td>
                                        <td>PGT</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>6</td>
                                        <td>MR. BIJENDER SAIN</td>
                                        <td>PGT</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>7</td>
                                        <td>MR. RAM GOPAL BHATT</td>
                                        <td>PGT</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>8</td>
                                        <td>MR. YOGESH</td>
                                        <td>MUSIC</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>9</td>
                                        <td>MR. SANTRAM</td>
                                        <td>PTI</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>10</td>
                                        <td>MR. BIJENDER SINGH</td>
                                        <td>TGT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>11</td>
                                        <td>MRS. CECILIA RENU</td>
                                        <td>TGT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>12</td>
                                        <td>MRS. ANITHA YADAV</td>
                                        <td>TGT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>13</td>
                                        <td>MRS. KAMLESH SHARMA</td>
                                        <td>TGT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>14</td>
                                        <td>MRS. SANGEETA YADAV</td>
                                        <td>TGT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>15</td>
                                        <td>MRS. RITU SHARMA</td>
                                        <td>TGT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>16</td>
                                        <td>MRS. MAMTA</td>
                                        <td>TGT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>17</td>
                                        <td>MRS. NEHA YADAV</td>
                                        <td>TGT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>18</td>
                                        <td>MRS. BEENA YADAV</td>
                                        <td>TGT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>19</td>
                                        <td>MRS. POONAM GUPTA</td>
                                        <td>TGT - COMP</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>20</td>
                                        <td>SR. BEENA P R</td>
                                        <td>TGT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>21</td>
                                        <td>SR. MARIA GEORGE</td>
                                        <td>TGT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>22</td>
                                        <td>MRS. NISHA KUMARI</td>
                                        <td>TGT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>23</td>
                                        <td>MR. SATISH KUMAR</td>
                                        <td>TGT</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>24</td>
                                        <td>MR. VIBIN</td>
                                        <td>TGT</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>25</td>
                                        <td>MRS. SAROJ YADAV</td>
                                        <td>TTG</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>26</td>
                                        <td>MR. LATNIC BIU</td>
                                        <td>TGT</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>27</td>
                                        <td>MRS. SUNITA SHARMA</td>
                                        <td>PRT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>28</td>
                                        <td>MRS. ANJU VERMA</td>
                                        <td>PRT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>29</td>
                                        <td>MRS. ANJU SHARMA</td>
                                        <td>PRT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>30</td>
                                        <td>MRS. SUMAN YADAV</td>
                                        <td>PRT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>31</td>
                                        <td>MRS. ASHMA</td>
                                        <td>PRT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>32</td>
                                        <td>MRS. TINKU KAUSHIK</td>
                                        <td>PRT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>33</td>
                                        <td>MRS. KAVITA SAINI</td>
                                        <td>PRT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>34</td>
                                        <td>MRS. SWARNIL SHARMA</td>
                                        <td>PRT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>35</td>
                                        <td>MRS. ANITHA YADAV</td>
                                        <td>PRT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>36</td>
                                        <td>MRS. PUNITA GOSWAMI</td>
                                        <td>PRT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>37</td>
                                        <td>MRS. VIKASH</td>
                                        <td>PRT- COMP</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>38</td>
                                        <td>MR. MANOJ KUMAR</td>
                                        <td>PTI</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>39</td>
                                        <td>MRS. KAVITA SHARMA</td>
                                        <td>PRT</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>40</td>
                                        <td>MRS. SAPANA SUNIL TIWARI</td>
                                        <td>PRT</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>41</td>
                                        <td>MRS. RAUNICA</td>
                                        <td>PRT- PTI</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>42</td>
                                        <td>MRS. GEETA YADAV</td>
                                        <td>NTT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>43</td>
                                        <td>MRS. RENU KUMARI</td>
                                        <td>NTT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>44</td>
                                        <td>MRS. MANISHA</td>
                                        <td>NTT</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>45</td>
                                        <td>MR. HARSH SHARMA</td>
                                        <td>ART</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>46</td>
                                        <td>RAJVEER YADAV</td>
                                        <td>PGT</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>47</td>
                                        <td>MRS. SUDESH KUMARI</td>
                                        <td>LIBRARIAN</td>
                                        <td>PERMANENT</td>
                                    </tr>
                                    <tr>
                                        <td>48</td>
                                        <td>MISS. OLANKA NAZARETH</td>
                                        <td>PRT</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div> */}
                        <table class="table table-bordered table-striped table-hover align-middle">
                            <thead class="table-dark">
                                <tr>
                                    <th>Category</th>
                                    <th>Name</th>
                                    <th>Status</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr><td>PRINCIPAL</td><td>FR. JOHN MARCUS FERNANDES</td><td></td></tr>
                                <tr><td>MANAGER</td><td>FR. RANJIT SORENG</td><td></td></tr>
                                <tr><td>COORDINATOR</td><td>MRS. RITU SHARMA</td><td></td></tr>

                                <tr class="table-secondary"><td colspan="3"><strong>NTT</strong></td></tr>
                                <tr><td></td><td>REENU KUMARI</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>MANISHA RANI</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>GEETA YADAV</td><td>CONTRACT</td></tr>
                                <tr><td></td><td>ANJANA YADAV</td><td>CONTRACT</td></tr>

                                <tr class="table-secondary"><td colspan="3"><strong>PRT</strong></td></tr>
                                <tr><td></td><td>ANJU VERMA</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>SUNITA SHARMA</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>KAVITA SAINI</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>ANJU SHARMA</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>SAVARNIL SHARMA</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>ANITA YADAV</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>SUMAN YADAV</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>TINKU KAUSHIK</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>PUNITA</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>SUDESH KUMARI</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>MANOJ KUMAR</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>KAVITA SHARMA</td><td>CONTRACT</td></tr>
                                <tr><td></td><td>SAPANA SUNIL TIWARI</td><td>CONTRACT</td></tr>
                                <tr><td></td><td>DIMPLE KUMARI</td><td>CONTRACT</td></tr>
                                <tr><td></td><td>RAUNICA</td><td>CONTRACT</td></tr>
                                <tr><td></td><td>PREETI AGGARWAL</td><td>CONTRACT</td></tr>

                                <tr class="table-secondary"><td colspan="3"><strong>TGT</strong></td></tr>
                                <tr><td></td><td>SANGEETA YADAV</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>BEENA</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>BIJENDER SINGH</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>BEENA PR</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>NEHA YADAV</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>VIBIN V</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>SAROJ YADAV</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>CECILIA RENU</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>SATISH KUMAR</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>PHILOMINA PAUL</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>NISHA KUMARI</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>MAMTA</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>POONAM GUPTA</td><td>PERMANENT</td></tr>
                                <tr><td></td><td>DIVYA ARORA</td><td>CONTRACT</td></tr>
                                <tr><td></td><td>KAMLESH SHARMA</td><td>CONTRACT</td></tr>
                                <tr><td></td><td>AJEET KUMAR</td><td>CONTRACT</td></tr>

                                <tr class="table-secondary"><td colspan="3"><strong>PGT</strong></td></tr>
                                <tr><td></td><td>MANISH SHARMA</td><td>CONTRACT</td></tr>
                                <tr><td></td><td>MAHESH KUMAR</td><td>CONTRACT</td></tr>
                                <tr><td></td><td>PRIYA</td><td>CONTRACT</td></tr>
                                <tr><td></td><td>NEERAJ KUMAR</td><td>CONTRACT</td></tr>
                                <tr><td></td><td>SANT RAM</td><td>CONTRACT</td></tr>
                                <tr><td></td><td>NAVEEN</td><td>CONTRACT</td></tr>
                                <tr><td></td><td>RAHUL KUMAR</td><td>CONTRACT</td></tr>
                                <tr><td></td><td>AJAY KUMAR</td><td>CONTRACT</td></tr>
                                <tr><td></td><td>SANTOSH KUMAR SHARMA</td><td>CONTRACT</td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default SchoolStaff